import styled from 'styled-components';
import dots from '../../assets/images/dots.svg';

const StyledBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgba(17, 19, 20, 0.9);
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledBackgroundDots = styled.div`
	width: 100%;
	height: 100%;
	background-image: url(${dots});
	background-repeat: repeat;
`;

export { StyledBackground, StyledBackgroundDots };
